import React, { Suspense, useEffect, useState } from "react";
import "./App.scss";
import Footer from "./containers/Footer";
import { ToastContainer } from "react-toastify";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ProtectedRoutes from "./routing/ProtectedRoutes";
import PublicRoutes from "./routing/PublicRoutes";
import { useDispatch, useSelector } from "react-redux";
import { getAppDetails } from "./redux/app/actions";

import Loader from "./assets/images/loader.webp";
import ScrollToTop from "./ScrollToTop";

import { APP_CONST, AFF_KEY_LS, AFF_QUERY_PARAM } from "./config/const";
import ExchangeSPMSportsLobbyPage from "./views/pages/privatePages/exchange/ExchangeSPMSportsLobbyPage";
import ALTGaming from "./views/pages/privatePages/altGaming";
import GatewaysList from "./views/pages/privatePages/deposit/gatewaysList";
import BeforeBonusTerms from "./views/pages/publicPages/FooterPages/BeforeBonusTerms";
// import WithdrawalPolicy from "./views/pages/privatePages/FooterPages/WithdrawalPolicy";
// import BeforeWithdrawlPolicy from "./views/pages/publicPages/FooterPages/BeforeWithdrawalPolicy";
import i18n from "./views/components/i18n";
import AboutUs from "./views/pages/privatePages/FooterPages/AboutUs";
import BeforeAboutUs from "./views/pages/publicPages/FooterPages/BeforeAboutUs";

const LiveCasino = React.lazy(() =>
  import("./views/pages/privatePages/livecasino")
);
const Aura = React.lazy(() => import("./views/pages/privatePages/aura"));
const PragmaticPlay = React.lazy(() =>
  import("./views/pages/privatePages/pragmaticplay")
);
const Dashboard = React.lazy(() =>
  import("./views/pages/privatePages/dashboard")
);
const Casino = React.lazy(() => import("./views/pages/privatePages/casino"));
const Qtech = React.lazy(() => import("./views/pages/privatePages/qtech"));
const Livegames = React.lazy(() =>
  import("./views/pages/privatePages/livegames")
);
const DepositList = React.lazy(() =>
  import("./views/pages/privatePages/deposit/list")
);

const Referral = React.lazy(() =>
  import("./views/pages/privatePages/referral")
);
const VIPLevel = React.lazy(() =>
  import("./views/pages/privatePages/vipLevel")
);
const Promotions = React.lazy(() =>
  import("./views/pages/privatePages/promotions")
);
const PublicSportsBook = React.lazy(() =>
  import("./views/pages/privatePages/sportsBook")
);
const ContactUs = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/ContactUs")
);
const PrivacyPolicy = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/PrivacyPolicy")
);
const ResponsibleGame = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/ResponsibleGame")
);
const FairPlay = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/FairPlay")
);
const GamesRule = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/GamesRule")
);
const Terms = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/Terms")
);
const BonusTerms = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/BonusTerms")
);
const KycPolicy = React.lazy(() =>
  import("./views/pages/privatePages/FooterPages/KycPolicy")
);

const BeforeLoginFooter = React.lazy(() =>
  import("./containers/BeforeLoginFooter")
);
const BeforeContactUs = React.lazy(() =>
  import("./views/pages/publicPages/FooterPages/BeforeContactUs")
);
const BeforeFairPlay = React.lazy(() =>
  import("./views/pages/publicPages/FooterPages/BeforeFairPlay")
);
const BeforeGamesRule = React.lazy(() =>
  import("./views/pages/publicPages/FooterPages/BeforeGamesRule")
);
const BeforePrivacyPolicy = React.lazy(() =>
  import("./views/pages/publicPages/FooterPages/BeforePrivacyPolicy")
);
const BeforeResponsibleGame = React.lazy(() =>
  import("./views/pages/publicPages/FooterPages/BeforeResponsibleGame")
);
const BeforeTerms = React.lazy(() =>
  import("./views/pages/publicPages/FooterPages/BeforeTerms")
);
const BeforeKycPolicy = React.lazy(() =>
  import("./views/pages/publicPages/FooterPages/BeforeKycPolicy")
);

const TestSportsBook = React.lazy(() =>
  import("./views/pages/privatePages/sportsBook/testSportsBook")
);
const DepositGateway = React.lazy(() =>
  import("./views/pages/privatePages/deposit/depositGateway")
);
const LuckyDraw = React.lazy(() =>
  import("./views/pages/privatePages/luckyDraw")
);
const IosInstruction = React.lazy(() =>
  import("./views/pages/publicPages/iosInstruction")
);
const AtlasLobby = React.lazy(() =>
  import("./views/pages/privatePages/sportsBook/atlasLobby")
);
const Home = React.lazy(() => import("./views/pages/privatePages/home"));
const Games = React.lazy(() => import("./views/pages/privatePages/games"));
const DynamicCasinoPage = React.lazy(() =>
  import("./views/pages/privatePages/games/DynamicCasinoPage")
);
const Cashier = React.lazy(() => import("./views/pages/privatePages/cashier"));
const LandingPage = React.lazy(() =>
  import("./views/pages/publicPages/landingPage")
);
const Deposit = React.lazy(() => import("./views/pages/privatePages/deposit"));
const Withdraw = React.lazy(() =>
  import("./views/pages/privatePages/withdraw")
);

const MobileNumber = React.lazy(() =>
  import("./views/pages/publicPages/register/mobileNumber")
);
const Profile = React.lazy(() => import("./views/pages/privatePages/profile"));
const Sports = React.lazy(() => import("./views/pages/privatePages/sports"));
const ExchangeLobbyPage = React.lazy(() =>
  import("./views/pages/privatePages/exchange/ExchangeLobbyPage")
);
const MatchDetailPage = React.lazy(() =>
  import("./views/pages/privatePages/sports/matchDetailPage")
);
const MyBets = React.lazy(() => import("./views/pages/privatePages/myBets"));
const WithdrawList = React.lazy(() =>
  import("./views/pages/privatePages/withdraw/WithdrawList")
);
// const ForgotPassword = React.lazy(() =>
//   import("./views/pages/publicPages/forgotPassword")
// );
// const ResetPassword = React.lazy(() =>
//   import("./views/pages/publicPages/forgotPassword/resetPassword")
// );
const Betby = React.lazy(() => import("./views/pages/privatePages/betby"));
const Maintenance = React.lazy(() =>
  import("./views/pages/publicPages/Maintenance")
);
const Register = React.lazy(() => import("./views/pages/publicPages/register"));
const Login = React.lazy(() => import("./views/pages/publicPages/login"));
// const MobileNumberVerify = React.lazy(() =>
//   import("./views/pages/publicPages/register/mobileNumberVerify")
// );
const Bonus = React.lazy(() => import("./views/pages/privatePages/bonus"));
const BonusCard = React.lazy(() =>
  import("./views/pages/privatePages/bonus/bonusCard")
);
const DynamicManualWithdrawGtw = React.lazy(() =>
  import("./views/pages/privatePages/withdraw/dynamicManual/gateway")
);

const App = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const { appDetails, organisationStatus } = useSelector((state) => state.app);
  const queryParams = new URLSearchParams(window.location.search);
  const affId = queryParams.get(AFF_QUERY_PARAM);

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = appDetails?.SEO_TITLE || "";
    document.canonical = appDetails?.LOGO_URL;
    // check organisation status
    if (
      organisationStatus !== null &&
      organisationStatus !== APP_CONST.ORGANISATION_STATUS.Live &&
      window.location.pathname.indexOf("maintenance") < 0
    ) {
      window.location.href = "/maintenance";
    }
  }, [appDetails]);

  const setVhUnit = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  useEffect(() => {
    dispatch(getAppDetails());
    setVhUnit();

    window.addEventListener("resize", setVhUnit);

    return () => {
      window.removeEventListener("resize", setVhUnit);
    };
  }, []);

  useEffect(() => {
    if (affId) {
      localStorage.setItem(AFF_KEY_LS, affId);
    }
  }, [affId]);
  const appLanguage = useSelector((state) => state.app.appLanguage);

  useEffect(() => {
    i18n.changeLanguage(appLanguage);
  }, [appLanguage]);
  return (
    <Router>
      <ScrollToTop />

      <ToastContainer
        closeButton={false}
        position="top-right"
        autoClose={1000}
      />
      <Suspense
        fallback={
          <div className="loaderImg">
            <img alt="Loader Image" src={Loader} />
          </div>
        }
      >
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoutes isAuth={isAuth}>
                <LandingPage />
                <BeforeLoginFooter />
              </PublicRoutes>
            }
          />
          <Route
            path="/maintenance"
            element={<Maintenance organisationStatus={organisationStatus} />}
          />
          <Route path="/atlas-lobby" element={<AtlasLobby isAuth={isAuth} />} />
          <Route
            path="/home"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Home />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/games-all"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Games />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route path="/vip-level" element={<VIPLevel />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/lucky-draw" element={<LuckyDraw />} />
          <Route path="/ios-instruction" element={<IosInstruction />} />
          <Route
            path="/casino/:casinoslug"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DynamicCasinoPage />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/casinogames"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Casino />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/qtechgames"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Qtech />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/livegames"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Livegames />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/sportsbook"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <PublicSportsBook />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/casino/:casinoslug/:gameslug"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DynamicCasinoPage />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/cashier"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Cashier />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/withdrawList"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <WithdrawList />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/deposit/list"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DepositList />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/mybets"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <MyBets />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/deposit/:gateway"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DepositGateway />
                {/* <BottomNav /> */}
              </ProtectedRoutes>
            }
          />
          <Route
            path="/withdraw/gateways/:gateway"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DynamicManualWithdrawGtw />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/gatewaylist"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <GatewaysList />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/deposit"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Deposit />
                <Footer />
              </ProtectedRoutes>
            }
          />
          {/* <Route
            path="/exchange"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Sports isAuth={isAuth} />
              </ProtectedRoutes>
            }
          /> */}
          <Route
            path="/withdraw"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Withdraw />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/mobile-number"
            element={
              <PublicRoutes isAuth={isAuth}>
                <MobileNumber />
              </PublicRoutes>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Profile />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/bonus"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Bonus />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/bonus/:id"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <BonusCard />
              </ProtectedRoutes>
            }
          />
          <Route path="test" element={<Sports />} />
          <Route
            // path="/sports/exchange"
            path="/sports/:gameId"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <ExchangeLobbyPage />
              </ProtectedRoutes>
            }
          />
          {/* <Route
            path="/spmsports"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <ExchangeSPMSportsLobbyPage />
              </ProtectedRoutes>
            }
          /> */}
          {/* <Route path="/betby" element={<Betby isAuth={isAuth} />} /> */}
          <Route
            path="/detail-page/:slug/:matchId/:marketId/:sportId"
            element={
              <>
                <MatchDetailPage isAuth={isAuth} />
                {isAuth ? <Footer /> : <BeforeLoginFooter />}
              </>
            }
          />
          <Route
            path="/referral"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Referral />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/contactus"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <ContactUs />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/aboutus"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <AboutUs />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/privacypolicy"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <PrivacyPolicy />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/responsiblegame"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <ResponsibleGame />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/fairplay"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <FairPlay />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/gamesrule"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <GamesRule />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/terms"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Terms />
              </ProtectedRoutes>
            }
          />
          {/* <Route
            path="/withdrawal-policy"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <WithdrawalPolicy />
              </ProtectedRoutes>
            }
          /> */}
          <Route
            path="/bonusterms"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <BonusTerms />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/beforebonusterms"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeBonusTerms />
              </PublicRoutes>
            }
          />
          {/* <Route
            path="/beforewithdrawal-policy"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeWithdrawlPolicy />
              </PublicRoutes>
            }
          /> */}
          <Route
            path="/aml_kyc_policy"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <KycPolicy />
              </ProtectedRoutes>
            }
          />
          {/* <Route path="/contactus" element={<ContactUs />} /> */}
          <Route
            path="/contactuss"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeContactUs />
              </PublicRoutes>
            }
          />
          <Route
            path="/aboutuss"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeAboutUs />
              </PublicRoutes>
            }
          />
          <Route
            path="/privacypolicys"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforePrivacyPolicy />
              </PublicRoutes>
            }
          />
          <Route
            path="/fairplays"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeFairPlay />
              </PublicRoutes>
            }
          />
          <Route
            path="/responsiblegames"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeResponsibleGame />
              </PublicRoutes>
            }
          />
          <Route
            path="/gamesrules"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeGamesRule />
              </PublicRoutes>
            }
          />
          <Route
            path="/termss"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeTerms />
              </PublicRoutes>
            }
          />
          <Route
            path="/aml_kyc_policys"
            element={
              <PublicRoutes isAuth={isAuth}>
                <BeforeKycPolicy />
              </PublicRoutes>
            }
          />
          <Route
            path="/sportsbooktest"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <TestSportsBook />
              </ProtectedRoutes>
            }
          />
          {/* <Route
            path="/forgot-password"
            element={
              <PublicRoutes isAuth={isAuth}>
                <ForgotPassword />
              </PublicRoutes>
            }
          /> */}
          {/* <Route
            path="/reset-password"
            element={
              <PublicRoutes isAuth={isAuth}>
                <ResetPassword />
              </PublicRoutes>
            }
          /> */}
          {/* <Route
            path="/register"
            element={
              <PublicRoutes isAuth={isAuth}>
                <Register />
                <Footer />
              </PublicRoutes>
            }
          /> */}
          <Route
            path="/sign-in"
            element={
              <PublicRoutes isAuth={isAuth}>
                <Login />
              </PublicRoutes>
            }
          />
          {/* <Route
            path="/verify-number"
            element={
              <PublicRoutes isAuth={isAuth}>
                <MobileNumberVerify />
              </PublicRoutes>
            }
          /> */}
          <Route
            path="/livecasino"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <LiveCasino />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/aura-games"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Aura />
              </ProtectedRoutes>
            }
          />
            <Route
            path="/pragmaticplay"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <PragmaticPlay />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/gap"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <ALTGaming />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Dashboard />
              </ProtectedRoutes>
            }
          />
          <Route path="*" exact={true} element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
